import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Tinashe Mangondo </span>
            from <span className="purple"> Harare , Zimbabwe</span>
            <br /> Bachelor of Science Honours Degree in Information
                  Technology (BSIT).
                  2016 - 2019 || Chinhoyi University || Zimbabwe || 1st Class.
            <br />
            <br />
            <h3>Certifications</h3>
            <br />
        
            <ul>
            <li className="about-activity">
              <ImPointRight /> Huawei HCIA Security V.3
            </li>
            <li className="about-activity">
              <ImPointRight /> Certified Solar System Installer
            </li>
            
          </ul>
            <br />
            <br />
           <h3>Apart from coding, some other activities that I love to do!</h3> 
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Watching Chelsea Football FC
            </li>
            <li className="about-activity">
              <ImPointRight /> Writing Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">TinasheMangondo</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
